import { Component, effect, input, Input, OnInit, SimpleChanges } from "@angular/core";
import { DonorCardService } from "../../../services/donor-card.service";
import { TableModule } from "primeng/table";
import { GenericButtonComponent } from "../../../../global/component/generic/generic-button/generic-button.component";
import { CommonModule } from "@angular/common";
import { DialogModule } from "primeng/dialog";
import { DropdownModule } from "primeng/dropdown";
import { ButtonModule } from "primeng/button";
import { CalendarModule } from "primeng/calendar";
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from "@angular/forms";
import { MessageService } from "primeng/api";
import { SharedService } from "../../../services/shared.service";
import { GenericConfirmationComponent } from "../../../../global/component/generic/generic-confirmation/generic-confirmation.component";

@Component({
    selector: 'app-donor-notes',
    templateUrl: './donor-notes.component.html',
    styleUrls: ['./donor-notes.component.scss'],
    standalone: true,
    imports: [GenericButtonComponent, CommonModule,
        TableModule, DialogModule, DropdownModule,
        ButtonModule, CalendarModule,
        ReactiveFormsModule, GenericConfirmationComponent
    ],
    providers: [SharedService, DonorCardService, MessageService]
})
export class DonorNotesComponent {
    @Input() donorId?: number;
    @Input() campaignId?: number;
    
    showAddEditNoteDialog: boolean = false;
    isEditMode: boolean = false;
    showDeleteNoteDialog: boolean = false;

    donorNoteTypes = undefined;
    donorNotes = [];
    donorNoteFormGroup: FormGroup;
    
    donorNoteToDelete: any = undefined;

    constructor(private formBuilder: FormBuilder,
        private sharedService: SharedService,
        private donorCardService: DonorCardService,
        private messageService: MessageService
    ) {
        this.donorNoteFormGroup = formBuilder.group({
            donorNoteId: [0],
            donorId: [this.donorId, Validators.required],
            donorNoteTypeId: ['', Validators.required],
            note: ['']
        })

        effect(() => {
            this.loadDonorNotes();
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['donorId'] || changes['campaignId']) {
            this.loadDonorNotes();
        }
    }

    loadDonorNotes(): void {
        if (this.donorId && this.campaignId) {
            this.donorCardService.getDonorNotes(this.donorId).subscribe({
                next: data => {
                    this.donorNotes = data;
                },
                error: err => {
                    console.error('Unable to retrieve donor notes. Please try again later.', err);
                },
            });
        }
    }
    
    loadDonorNoteTypes(): void {
        if (this.campaignId && !this.donorNoteTypes) {
            this.donorCardService.getDonorNoteTypes(this.campaignId).subscribe({
                next: data => {
                    this.donorNoteTypes = data;
                },
                error: err => {
                    console.error('Unable to retrieve donor note types. Please try again later.', err);
                },
            });
        }
    }
    
    onAddEditDonorNote(donorNote?: any) {
        this.loadDonorNoteTypes();
        if (!donorNote) {
            this.isEditMode = false;
            // new fund code
            donorNote = {
                donorNoteId: 0,
                donorId: this.donorId,
                donorNoteTypeId: '',
                note: ''
            };
        }
        else
            this.isEditMode = true;

        this.donorNoteFormGroup.reset();
        this.donorNoteFormGroup.patchValue(donorNote);
        this.showAddEditNoteDialog = true;
    }

    onDeleteDonorNote(donorNote: any) {
        this.donorNoteToDelete = donorNote;
        this.showDeleteNoteDialog = true;
    }

    onDeleteDonorNoteConfirm(donorNote: any) {
        this.donorCardService.deleteDonorNote(donorNote).subscribe({
            next: (res) => {
                this.loadDonorNotes();
                this.showDeleteNoteDialog = false;
            },
            error: (result) => {
                var errorMessage = 'An error occurred while deleting donor note.';
                if (result?.error?.message)
                    errorMessage = this.sharedService.decodeHtml(result.error.message);
                this.messageService.add({ severity: 'error', summary: 'Error', detail: errorMessage });
            }
        });
    }

    onDeleteDonorNoteCancel() {
        this.showDeleteNoteDialog = false;
    }

    closeAddEditDialog(): void {
        this.showAddEditNoteDialog = false;
    }

    saveDonorNote(): void {

        if(this.donorNoteFormGroup.value.donorNoteTypeId === "") {
        this.donorNoteFormGroup.get('donorNoteTypeId')?.markAsTouched();
        }
        if(this.donorNoteFormGroup.value.note === "") {
        this.donorNoteFormGroup.get('note')?.markAsTouched();
        }

        if (this.donorNoteFormGroup.valid) {

            const donorNote: any = {
                donorNoteId: this.donorNoteFormGroup.value.donorNoteId,
                donorId: this.donorId,
                donorNoteTypeId: this.donorNoteFormGroup.value.donorNoteTypeId,
                note: this.donorNoteFormGroup.value.note,
            };
        
            this.donorCardService.saveDonorNote(donorNote).subscribe({
                next: (res) => {
                    this.loadDonorNotes();
                    this.showAddEditNoteDialog = false;
                },
                error: (result) => {
                    var errorMessage = 'An error occurred while saving donor note.';
                    if (result?.error?.message)
                        errorMessage = this.sharedService.decodeHtml(result.error.message);
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: errorMessage });
                }
            });
        }
    }
}